/* eslint-disable import/prefer-default-export */
export async function postLoginService(csrfToken, loginPayload) {
  const loginUrl = '/authentication/sessions.json';

  const response = await fetch(loginUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(loginPayload),
  });

  if (!response.ok) {
    const parsedResponse = await response.json();
    throw parsedResponse.message;
  }
  return response;
}

export async function postPasswordResetService(csrfToken, identity) {
  const passwordResetUrl = '/authentication/password_resets.json';

  const response = await fetch(passwordResetUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ identity }),
  });

  if (!response.ok) {
    const parsedResponse = await response.json();
    throw parsedResponse.message;
  }
  return response;
}

export async function postPasswordChangeService(csrfToken, passwordPayload) {
  const passwordUrl = '/authentication/passwords.json';

  const response = await fetch(passwordUrl, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify(passwordPayload),
  });

  if (!response.ok) {
    const parsedResponse = await response.json();
    throw parsedResponse.message;
  }
  return response;
}

export async function postCheckUsernameSso(csrfToken, userName) {
  const checkUsername = '/auth/gateway/check_username.json';

  const response = await fetch(checkUsername, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({ username: userName?.trim() }),
  });

  if (!response.ok) {
    const parsedResponse = await response.json();
    throw parsedResponse.message;
  }
  return response;
}
